function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.size_options = this.querySelector('.product-card-sizes');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.size_options) {
        this.enableSizeOptions();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image-link');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });

    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });

        swatch.addEventListener('mouseover', () => {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }
          if (this.size_options) {
            this.current_options[this.color_index] = swatch.querySelector('span').innerText;
            this.updateMasterId();
          }
          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
        featured_image = this.querySelector('.product-featured-image'),
        has_hover = featured_image.classList.contains('thb-hover'),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(',');

      this.updateMasterId();

      size_parent.addEventListener('mouseenter', () => {
        if (has_hover) {
          featured_image.classList.remove('thb-hover');
        }
      }, {
        passive: true
      });
      size_parent.addEventListener('mouseleave', () => {
        if (has_hover) {
          featured_image.classList.add('thb-hover');
        }
      }, {
        passive: true
      });
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();

          if (size.classList.contains('is-disabled')) {
            return;
          }
          this.current_options[this.size_index] = size.querySelector('span').innerText;
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          let formData = new FormData();

          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return;
              }
              this.renderContents(response);

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {

        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });

          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
              input.classList.add('is-disabled');
            });
          }
        }

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }

        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}


/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');

      this.onClick = (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      };
      // Add functionality to buttons
      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('panel:close', this.onClick.bind(this));
      if (!this.cc.hasAttribute('initialized')) {
        this.cc.addEventListener('click', this.onClick.bind(this));
        this.cc.setAttribute('initialized', '');
      }

    }
    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel.active');

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains('product-drawer') || document.body.classList.contains('open-quick-view')) {
        this.close_quick_view();
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    }
    close_quick_view() {
      let panel = document.getElementById('Product-Drawer');

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            panel.querySelector('#Product-Drawer-Content').innerHTML = '';
          }, 500);
        }
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {

      let button = document.getElementById('cart-drawer-toggle');


      // Add functionality to buttons
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        this.classList.add('active');
        this.focus();
        setTimeout(() => {
          this.querySelector('.product-recommendations--full')?.classList.add('active');
        });
        dispatchCustomEvent('cart-drawer:open');
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.notesToggle();
      this.removeProductEvent();
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {
      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');

          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    notesToggle() {
      let notes_toggle = document.getElementById('order-note-toggle');

      if (!notes_toggle) {
        return;
      }

      notes_toggle.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.add('active');
      });
      notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
        el.addEventListener('click', (event) => {
          notes_toggle.nextElementSibling.classList.remove('active');
          this.saveNotes();
        });
      });
    }
    saveNotes() {
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': document.getElementById('mini-cart__notes').value
        })
      });
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      this.querySelector('.product-recommendations--full')?.classList.remove('active');

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          this.removeProductEvent();
          this.notesToggle();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

          this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
        });
    }
    refresh() {
      this.querySelector('.product-recommendations--full')?.classList.remove('active');
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
          this.notesToggle();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc');
        this.body.classList.add('open-quick-view');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          this.drawer.querySelector('.product-quick-images--container').classList.add('active');
        });
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});


// Added by OCS - For color swatch color change on hover
function initializeProductImageHover() {
  document.querySelectorAll('.product-card').forEach(function(productCard) {
    productCard.querySelectorAll('.color_swatch li').forEach(function(item) {
      item.addEventListener('mouseover', function() {
        var imageUrl = item.querySelector('span').getAttribute('data-image-url');
        var mainProductImage = productCard.querySelector('.product-primary-image');
        mainProductImage.setAttribute('src', imageUrl);
        mainProductImage.setAttribute('srcset', imageUrl);
      });
  
      item.addEventListener('mouseout', function() {
        var masterUrl = productCard.querySelector('div.active_picker').getAttribute('data-image-url');
        var mainProductImage = productCard.querySelector('.product-primary-image');
        mainProductImage.setAttribute('src', masterUrl);
        mainProductImage.setAttribute('srcset', masterUrl);
      });
    });
  });
}

if (document.body.classList.contains('template-product') || document.body.classList.contains('template-cart')) {
  setTimeout(function() {
    if (document.querySelectorAll('.product-card').length > 0) {
      initializeProductImageHover();
    }
  }, 2000); // 2 seconds timeout for product/cart pages
} else {
  setTimeout(function() {
    if (document.querySelectorAll('.product-card').length > 0) {
      initializeProductImageHover();
    }
  }, 500); // 1 second timeout for other pages
}



/*Added by ocs - To apply Discount coupon code in cart & cart drawer */
document.addEventListener("DOMContentLoaded", function() {
  applyDiscountLogic();

  document.addEventListener('cart:item-added', function() {
    //console.log("Cart item added, applying discount logic");
    applyDiscountLogic();
  });
});


function applyDiscountLogic() {
    console.log("Discount function called");
    
    let isCartDrawerOpen = document.body.classList.contains('open-cart');
    let parentClass = isCartDrawerOpen ? ".cart-drawer" : ".thb-cart-form";

    // Update the query selectors to include the parent class
    // let clearBtn = document.querySelector(`${parentClass} #clear-discount-btn`);
    let applyBtn = document.querySelector(`${parentClass} #apply-discount-btn`);
    let discountCodeError = document.querySelector(`${parentClass} #discount-code-error`);
    let discountCodeWrapper = document.querySelector(`${parentClass} #applied-discount-code .applied-discount-code-wrapper`);
    let discountCodeValue = document.querySelector(`${parentClass} #applied-discount-code .applied-discount-code-value`);
    let discountCodeInput = document.querySelector(`${parentClass} #discount-code-input`);
    let totalCartSelector = document.querySelector(`${parentClass} .checkout-button span > span`);
    let PAFValidatedCode = document.querySelector(`${parentClass} #paf_validated_code`);
    let votreUid = document.querySelector(`${parentClass} #votre_uid`);

    var langHtml = document.querySelector("html"); 
    if(langHtml.getAttribute("lang") == "fr") {
      appliedDiscount = "Réduction appliquée :";
      noDiscountApplied = "Aucune réduction n'est appliquée";
      enterValidCoupon = "Veuillez saisir des informations valides.";
      buttonText = "Appliquer";
    }else if(langHtml.getAttribute("lang") == "en"){
      appliedDiscount = "Discount applied :";
      noDiscountApplied = "No discount is applied";
      enterValidCoupon = "Please enter a valid details.";
      buttonText = "Add";
    }else if(langHtml.getAttribute("lang") == "es"){
      appliedDiscount = "Descuento aplicado :";
      noDiscountApplied = "No se aplica ningún descuento";
      enterValidCoupon = "Por favor, introduzca datos válidos.";
      buttonText = "Añadir";
    }
  
    // Store the original total price before discount is applied
    let originalTotalPrice = totalCartSelector ? totalCartSelector.textContent.trim() : "";
  
    // Check if there's a discount applied in checkout and sync it with cart page
    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      //console.log(data);
      
      const detailsTag = document.querySelector('.cart_discount_coupon');
      
      if (data && data.total_discount > 0) {
        if (data.cart_level_discount_applications && data.cart_level_discount_applications.length > 0) {
          let discountInfo = data.cart_level_discount_applications[0]; // Get the first applied discount
          let discountTitle = discountInfo.title;
          let discountAmount = (data.total_discount / 100).toFixed(2);
          
          // Format the amount if needed (remove ,00 if it's a whole number)
          let formattedDiscountAmount = discountAmount.includes('.00') 
                                        ? discountAmount.replace('.00', '') 
                                        : discountAmount.replace('.', ',');

          if(discountCodeValue){
            discountCodeValue.innerHTML = appliedDiscount +` ${formattedDiscountAmount} EUR`;
          }
  
          if (discountCodeWrapper) {
            discountCodeWrapper.style.display = "inline-flex";
          }
  
          if (detailsTag) {
            detailsTag.setAttribute('open', '');
          }
        }
      } else {
        if(discountCodeValue){
          //discountCodeValue.innerHTML = noDiscountApplied;
          discountCodeValue.classList.add('hide_remove');
          //clearBtn.classList.add('hide_remove');
        }
        if (detailsTag) {
          detailsTag.removeAttribute('open');
        }
      }
    })
    .catch(error => {
      console.error('Pre code checking error:', error);
    });
  
    if (applyBtn) {
      applyBtn.addEventListener("click", function(e) {
        discountCodeInput.style.border = '1px solid #dedede';
        votreUid.style.border = '1px solid #dedede';
        e.preventDefault();
        if (discountCodeInput.value !== '' && votreUid.value !== '') {
          applyDiscountCode();
        } else {
          discountCodeInput.style.border = '1px solid red';
          votreUid.style.border = '1px solid red';
        }
      });
    }
  
    // if (clearBtn) {
    //   clearBtn.addEventListener("click", function(e) {
    //     e.preventDefault();
    //     clearDiscount(e);
    //     discountCodeInput.style.border = '1px solid #dedede';
    //   });
    // }
  
    function clearDiscount(e) {
      e.preventDefault();
      discountCodeValue.innerHTML = "";
      discountCodeError.innerHTML = "";
      discountCodeInput.value = "";
      clearLocalStorage();
    
      if (totalCartSelector) {
        totalCartSelector.innerHTML = originalTotalPrice;
      }
    
      // Use Shopify's Cart API to remove any applied discounts
      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          attributes: {
            discount_code: null
          }
        })
      })
      .then(response => response.json())
      .then(data => {
        //console.log('Discount cleared from the cart:', data);
        // Optionally reload the page or update the cart UI
        return;
      })
      .catch(error => {
        console.error('Error clearing discount from cart:', error);
      });
    }
  
    function clearLocalStorage() {
      if (discountCodeWrapper) discountCodeWrapper.style.display = "none";
      localStorage.removeItem("discountCode");
    }

    function getVerifiedCode(){
      return new Promise((resolve, reject) => {
        event.preventDefault();

        var pafUid = votreUid.value;
        var pafAviatorCode = discountCodeInput.value;
        var pafcCustomerId = document.getElementById("customer_id").value;
        
        var inputs = document.querySelectorAll("#paf_code_container input[type='text']");
        inputs.forEach(function(input) {
            input.value = '';
        });
    
        // console.log('UID:-', pafUid);
        // console.log('Aviator Code:-', pafAviatorCode);
        // console.log('Customer Id:-', pafcCustomerId);
        
        fetch('https://ps16.store-and-supply.com/shopify_apps/redskins/paf_code/paf_code_check.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                pafUid: pafUid,
                pafAviatorCode: pafAviatorCode,
                pafcCustomerId: pafcCustomerId
            })
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
            }
            return response.text(); // Assuming the response is plain text; use .json() if it's JSON
        })
        .then(verifiedCodeValue => {
            console.log("Verified Code from response: " + verifiedCodeValue);
            resolve(verifiedCodeValue);
        })
        .catch(error => {
            console.error('Error posting data:', error);
        });
      });
    }
  
    function applyDiscountCode() {
      var pafcCustomerId = document.getElementById("customer_id").value;
      var langHtml = document.querySelector("html");
      if(langHtml.getAttribute("lang") == "fr") {
        loginErrorMsg = "Merci de créer ou de vous connecter à votre compte pour profiter de vôtre réduction";
      }else if(langHtml.getAttribute("lang") == "en"){
        loginErrorMsg = "Please create or log in to your account to take advantage of your discount";
      }else if(langHtml.getAttribute("lang") == "es"){
        loginErrorMsg = "Cree su cuenta o conéctese a ella para beneficiarse del descuento.";
      }

      if (!pafcCustomerId || pafcCustomerId.trim() === "guest") {
        if (discountCodeError) discountCodeError.innerHTML = loginErrorMsg;
        if (discountCodeWrapper) discountCodeWrapper.style.display = "none";
        if (discountCodeValue) discountCodeValue.innerHTML = "";
        applyBtn.innerHTML = `<span>${buttonText}</span>`;
        return; // ⛔ Stop here — do not continue discount logic
      }
      
      applyBtn.innerHTML = "<span class='loader'></span>";
    
      getVerifiedCode().then(verifiedCodeValue => {
        let code = verifiedCodeValue;

        // ✅ Check if this code is already applied
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            let alreadyApplied = false;
    
            // Check cart-level discount
            if (Array.isArray(cart.cart_level_discount_applications)) {
              alreadyApplied = cart.cart_level_discount_applications.some(i => i.title === code);
            }
    
            // Check product-level discount
            if (!alreadyApplied && Array.isArray(cart.items)) {
              cart.items.forEach(item => {
                if (Array.isArray(item.discounts)) {
                  item.discounts.forEach(discount => {
                    if (discount.title === code) {
                      alreadyApplied = true;
                    }
                  });
                }
              });
            }
    
            if (alreadyApplied) {
              // 🎯 Coupon already applied — show message
              var langHtml = document.querySelector("html");
              if(langHtml.getAttribute("lang") == "fr") {
                alreadyCouponApplied = "Le coupon PAF est déjà appliqué";
              }else if(langHtml.getAttribute("lang") == "en"){
                alreadyCouponApplied = "Already PAF coupon is applied";
              }else if(langHtml.getAttribute("lang") == "es"){
                alreadyCouponApplied = "Ya se aplica el cupón PAF";
              }
              if (discountCodeError) {
                discountCodeError.innerHTML = alreadyCouponApplied;
              }
              applyBtn.innerHTML = `<span>${buttonText}</span>`;
              return;
            }
    
            // 🔁 If not already applied — apply the coupon via Shopify redirect
            // Step 1: Apply discount via redirect (Shopify's way to apply it)
            fetch(`/discount/${code}`)
              .then(() => {
                // Step 2: Wait a bit before checking if the discount is applied
                setTimeout(() => {
                  fetch('/cart?view=discount', {
                    headers: {
                      accept: 'application/json'
                    }
                  })
                  .then(res => res.text())
                  .then(data => {
                    let dataObjectNew;
                    try {
                      dataObjectNew = JSON.parse(data);
                    } catch (e) {
                      applyBtn.innerHTML = `<span>${buttonText}</span>`;
                      return;
                    }
                    console.log('Cart JSON after applying code:', dataObjectNew);
                    
                    let matched = false;
                    let formattedDiscount = "";
                    let discountCodeMatch = null;
        
                    // Check for cart-level discount
                    // if (Array.isArray(dataObjectNew.cart_level_discount_applications)) {
                    //   dataObjectNew.cart_level_discount_applications.forEach(i => {
                    //     if (i.title === code) {
                    //       matched = true;
                    //       formattedDiscount = formatDiscountAmount(i.total_allocated_amount);
                    //     }
                    //   });
                    // }
        
                    // Check for product-level discount
                    if (!matched && Array.isArray(dataObjectNew.items)) {
                      dataObjectNew.items.forEach(item => {
                        if (Array.isArray(item.discounts)) {
                          item.discounts.forEach(discount => {
                            console.log(discount.title);
                            console.log(code);
                            if (discount.title === code) {
                              matched = true;
                              formattedDiscount = formatDiscountAmount(discount.amount);
                            }
                          });
                        }
                      });
                    }

                    // Find entered code in the returned discount_codes array
                    if (Array.isArray(dataObjectNew.discount_codes)) {
                      discountCodeMatch = dataObjectNew.discount_codes.find(dc =>
                        dc.code?.toLowerCase() === code.trim().toLowerCase()
                      );
                    }
                    
                    console.log(discountCodeMatch);

                    // First: check if code even matched
                    if (!discountCodeMatch || discountCodeMatch.code === "code mis-matched") {
                      // ❌ Entered an invalid code
                      if (discountCodeValue) discountCodeValue.innerHTML = "";
                      clearLocalStorage();
                      if (discountCodeError) discountCodeError.innerHTML = enterValidCoupon;
                      return;
                    }
                    
                    // Second: code matched but not applicable
                    if (discountCodeMatch.applicable === false) {
                      if (discountCodeError) {
                        let notApplicableMsg = "This discount is not applicable for this product(s).";
                        const langHtml = document.querySelector("html");
                        if (langHtml.getAttribute("lang") === "fr") {
                          notApplicableMsg = "Cette réduction n'est pas applicable à ce(s) produit(s).";
                        } else if (langHtml.getAttribute("lang") === "es") {
                          notApplicableMsg = "Este descuento no es aplicable para este(s) producto(s).";
                        }
                        discountCodeError.innerHTML = notApplicableMsg;
                      }
                    
                      if (discountCodeValue) discountCodeValue.innerHTML = "";
                      clearLocalStorage();
                      return;
                    }
                    
                    // Third: valid code and applicable — now check product-level discount just for showing discounted subtotal
                    if (Array.isArray(dataObjectNew.items)) {
                      dataObjectNew.items.forEach(item => {
                        if (Array.isArray(item.discounts)) {
                          item.discounts.forEach(discount => {
                            if (discount.title === code) {
                              matched = true;
                            }
                          });
                        }
                      });
                    }
                    
                    let totalPrice = dataObjectNew.total_price;
                    if (totalPrice && !isNaN(totalPrice)) {
                      let formattedPrice = formatPrice(totalPrice);
                      let localStorageValue = {
                        code: code.trim(),
                        totalCart: formattedPrice
                      };
                      localStorage.setItem("discountCode", JSON.stringify(localStorageValue));
                      if (totalCartSelector) totalCartSelector.innerHTML = formattedPrice;
                    }
                    
                    document.dispatchEvent(new CustomEvent('cart:refresh'));
                    discountMessageDisplay();
                  })
                  .finally(() => {
                    applyBtn.innerHTML = `<span>${buttonText}</span>`;
                  });
                }, 600); // Slight delay after fetch(`/discount/${code}`) to ensure update
              });
          });
      });
    }
}

function formatDiscountAmount(amountStr) {
  var format = window.theme.settings.money_with_currency_format || "${{amount}}";
  var amountStr = formatMoney(amountStr, format); //commented by ocs

  let amountWithoutCurrency = amountStr.replace("EUR", "").trim();
  let amount = parseFloat(amountWithoutCurrency.replace(",", "."));

  // Check if the amount ends in .00 (which would be displayed as ,00)
  if (amount % 1 === 0) {
    // Return only the whole number part if it ends in ,00
    return Math.floor(amount).toLocaleString('de-DE') + '€';
  } else {
    // Otherwise, return the formatted amount with two decimal places
    return amount.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + '€';
  }
}

function formatPrice(price) {
  let priceInEuros = price / 100; // Assuming the price is in cents
  if (priceInEuros % 1 === 0) {
      return Math.floor(priceInEuros).toLocaleString('de-DE') + ' EUR'; // Whole number, no decimals
  } else {
      return priceInEuros.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' EUR'; // With two decimals
  }
}

function discountMessageDisplay() {
  var langHtml = document.querySelector("html"); 
  if(langHtml.getAttribute("lang") == "fr") {
    appliedDiscount = "Réduction appliquée :";
    noDiscountApplied = "Aucune réduction n'est appliquée";
    enterValidCoupon = "Veuillez saisir des informations valides.";
    buttonText = "Appliquer";
  }else if(langHtml.getAttribute("lang") == "en"){
    appliedDiscount = "Discount applied :";
    noDiscountApplied = "No discount is applied";
    enterValidCoupon = "Please enter a valid details.";
    buttonText = "Add";
  }else if(langHtml.getAttribute("lang") == "es"){
    appliedDiscount = "Descuento aplicado :";
    noDiscountApplied = "No se aplica ningún descuento";
    enterValidCoupon = "Por favor, introduzca datos válidos.";
    buttonText = "Añadir";
  }
  
  setTimeout(() => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const parentClass = document.body.classList.contains('open-cart') ? ".cart-drawer" : ".thb-cart-form";

        // Inject container again if it doesn't exist
                let wrapper = document.querySelector(`${parentClass} #applied-discount-code`);
        if (!wrapper) {
          const targetLocation = document.querySelector(`${parentClass} .discount-code-section`) || document.querySelector(`${parentClass} .cart__footer`);
          if (!targetLocation) return;

          wrapper = document.createElement('span');
          wrapper.id = 'applied-discount-code';
          wrapper.innerHTML = `
            <span class="applied-discount-code-wrapper" style="display:inline-flex;">
              <span class="applied-discount-code-value"></span>
            </span>`;
          targetLocation.prepend(wrapper);
        }

        const discountValue = wrapper.querySelector('.applied-discount-code-value');
        const discountWrapper = wrapper.querySelector('.applied-discount-code-wrapper');

        let found = false;
        let totalDiscountAmount = 0;
        var langHtml = document.querySelector("html");
        if(langHtml.getAttribute("lang") == "fr") {
          appliedDiscountText = "Réduction appliquée :";
        }else if(langHtml.getAttribute("lang") == "en"){
          appliedDiscountText = "Discount applied :";
        }else if(langHtml.getAttribute("lang") == "es"){
          appliedDiscountText = "Descuento aplicado :";
        }
        
        // Check cart-level discounts
        if (Array.isArray(cart.cart_level_discount_applications)) {
          cart.cart_level_discount_applications.forEach(i => {
            if (i.title.startsWith("PAF")) {
              found = true;
              totalDiscountAmount += parseFloat(i.total_allocated_amount);
            }
          });
        }
        
        // Check item-level discounts
        if (Array.isArray(cart.items)) {
          cart.items.forEach(item => {
            if (Array.isArray(item.discounts)) {
              item.discounts.forEach(discount => {
                if (discount.title.startsWith("PAF")) {
                  found = true;
                  totalDiscountAmount += parseFloat(discount.amount);
                }
              });
            }
          });
        }
        
        if (found) {
          discountWrapper.style.display = "inline-flex";
          //discountValue.innerHTML = `${appliedDiscountText} ${formattedAmount}`;
          discountValue.innerHTML = `${appliedDiscountText} ${formatDiscountAmount(totalDiscountAmount)}`;
        
          const discountContainer = document.querySelector("#paf_code_container");
          if (discountContainer && !discountContainer.classList.contains("show")) {
            discountContainer.classList.add("show");
            discountContainer.style.maxHeight = "220px";
          }

          const aviatorLink = document.querySelector('.aviator_link');
          const pafCodeContainer = document.getElementById('paf_code_container');
        
          aviatorLink.addEventListener('click', function(event) {
            event.preventDefault();
            if (pafCodeContainer.classList.contains('show')) {
              pafCodeContainer.style.maxHeight = `${pafCodeContainer.scrollHeight}px`;
              pafCodeContainer.offsetHeight;
              pafCodeContainer.classList.remove('show');
              pafCodeContainer.style.maxHeight = '0';
            } else {
              pafCodeContainer.style.maxHeight = `220px`;
              pafCodeContainer.classList.add('show');
              pafCodeContainer.offsetHeight;
              pafCodeContainer.style.maxHeight = `220px`;
            }
          });
        } else {
          const discountCodeError = document.querySelector(`${parentClass} #discount-code-error`);
          const discountContainer = document.querySelector("#paf_code_container");
          if (discountCodeError && discountContainer && !discountContainer.classList.contains("show")) {
            discountContainer.classList.add("show");
            discountContainer.style.maxHeight = "220px";
            discountCodeError.innerText = enterValidCoupon;
          }
        }
      });
  }, 700); // slight delay to let Shopify render cart
}
// Smart Wishlist Fix - Version finale
(function() {
  'use strict';
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistObserver);
  } else {
    initWishlistObserver();
  }
  
  function initWishlistObserver() {
    const productGrid = document.querySelector('#product-grid');
    
    if (!productGrid) {
      console.log('Smart Wishlist Fix: No product grid found');
      return;
    }
    
    console.log('Smart Wishlist Fix: Observer initialized');
    
    const observer = new MutationObserver(function(mutations) {
      let hasNewProducts = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (
                node.classList && node.classList.contains('column') ||
                node.querySelector && node.querySelector('.product-card')
            )) {
              hasNewProducts = true;
            }
          });
        }
      });
      
      if (hasNewProducts) {
        console.log('Smart Wishlist Fix: New products detected, reinitializing...');
        setTimeout(reinitializeWishlist, 500);
      }
    });
    
    observer.observe(productGrid, {
      childList: true,
      subtree: false
    });
  }
  
  function reinitializeWishlist() {
    if (typeof window.ReloadSmartWishlist === 'function') {
      console.log('Smart Wishlist Fix: Calling ReloadSmartWishlist()');
      try {
        window.ReloadSmartWishlist();
        console.log('Smart Wishlist Fix: Successfully reloaded');
      } catch (e) {
        console.error('Smart Wishlist Fix: Error calling ReloadSmartWishlist:', e);
        fallbackInitialization();
      }
    } else {
      console.log('Smart Wishlist Fix: ReloadSmartWishlist not found, trying fallback');
      fallbackInitialization();
    }
  }
  
  function fallbackInitialization() {
    if (typeof window.SmartWishlistMain === 'function') {
      console.log('Smart Wishlist Fix: Calling SmartWishlistMain()');
      try {
        window.SmartWishlistMain();
      } catch (e) {
        console.error('Smart Wishlist Fix: Error calling SmartWishlistMain:', e);
      }
    }
    
    if (typeof window.SmartWishlistScripts === 'function') {
      console.log('Smart Wishlist Fix: Calling SmartWishlistScripts()');
      try {
        window.SmartWishlistScripts();
      } catch (e) {
        console.error('Smart Wishlist Fix: Error calling SmartWishlistScripts:', e);
      }
    }
  }
  
})();